<template>
  <div class="main">
    <Login
      :defaultActiveKey="type"
      :onTabChange="onTabChange"
      :onSubmit="handleSubmit"
      v-ant-ref="
        form => {
          this.loginForm = form;
        }
      "
    >
      <Tab key="account" tab="账户密码登录">
        <VNodes
          v-if="status === 'error' && type === 'account' && !submitting"
          :vnodes="renderMessage('account')"
        />
        <UserName
          name="username"
          placeholder="用户名："
          :rules="[
            {
              required: true,
              message: '请输入用户名!'
            }
          ]"
        />
        <Password
          name="pwd"
          placeholder="密码："
          :rules="[{ required: true, message: '请输入密码！' }]"
          :onPressEnter="
            e => {
              e.preventDefault();
              this.form.validateFields(this.handleSubmit);
            }
          "
        />
      </Tab>
      <div>
        <a-checkbox :checked="autoLogin" @change="changeAutoLogin"
          >自动登录</a-checkbox
        >
        <a style="float: right" href="javascript:void(0)" @click="forgetPwd"
          >忘记密码</a
        >
      </div>
      <Submit :loading="submitting">登录</Submit>
      <!-- <div class="other">
        <router-link class="register" to="/user/register">注册账户</router-link>
      </div> -->
    </Login>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Login from "@/components/Login";
import md5 from "md5";

const { Tab, UserName, Password, Submit } = Login;

export default {
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    },
    Login,
    Tab,
    UserName,
    Password,
    Submit
  },
  data() {
    return {
      type: "account",
      autoLogin: true,
      submitting: false,
      count: 0,
      tabs: []
    };
  },
  computed: {
    ...mapState({
      status: state => state.status
    })
  },
  methods: {
    // ...mapActions("login", ["login"]),
    ...mapActions(["login"]),
    ...mapMutations("login", ["changeLoginStatus"]),
    handleSubmit(err, values) {
      //const { type } = this.$data;
      if (!err) {
        this.submitting = true;
        this.login({
          username: values.username,
          pwd: md5(values.pwd)
        }).then(() => {
          this.submitting = false;
        });
      }
    },
    onTabChange(type) {
      this.type = type;
      this.changeLoginStatus({
        status: false,
        currentAuthority: "guest"
      });
    },
    changeAutoLogin(e) {
      this.autoLogin = e.target.checked;
    },
    renderMessage(type) {
      return (
        <a-alert
          style="margin-bottom: 24px"
          message={type === "account" ? "用户名或密码错误" : "验证码错误"}
          type="error"
          showIcon
        />
      );
    },
    forgetPwd: function() {
      this.$notification.info({
        message: "Tips",
        description: "请联系管理员!"
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "~ant-design-vue/lib/style/themes/default.less";

.main {
  width: 388px;
  margin: 0 auto;
  @media screen and (max-width: @screen-sm) {
    width: 95%;
  }

  .icon {
    margin-left: 16px;
    color: rgba(0, 0, 0, 0.2);
    font-size: 24px;
    vertical-align: middle;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: @primary-color;
    }
  }

  .other {
    margin-top: 24px;
    line-height: 22px;
    text-align: left;

    .register {
      float: right;
    }
  }
  .login {
    /deep/ .ant-tabs .ant-tabs-bar {
      margin-bottom: 24px;
      text-align: center;
      border-bottom: 0;
    }

    /deep/ .ant-form-item {
      margin: 0 2px 24px;
    }

    .getCaptcha {
      display: block;
      width: 100%;
    }

    .icon {
      margin-left: 16px;
      color: rgba(0, 0, 0, 0.2);
      font-size: 24px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: @primary-color;
      }
    }

    .other {
      margin-top: 24px;
      line-height: 22px;
      text-align: left;

      .register {
        float: right;
      }
    }

    .prefixIcon {
      color: @disabled-color;
      font-size: @font-size-base;
    }

    .submit {
      width: 100%;
      margin-top: 24px;
    }
  }
}
</style>
